import secureLocalStorage from "react-secure-storage";
import { formatNumber } from "@telerik/kendo-intl";
import * as React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
export default class MitigationCurrencyFormat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      temp:this.props.dataItem[this.props.field]
    };
  }
  componentDidUpdate=()=>{
    if(this.props.dataItem.inEdit&&document.getElementById(this.props.field)){
      document.getElementById(this.props.field).focus();
    } 
  }
  handleChange = (e) => {
    
    if(this.props.isOpportunity==="Threat"){
      var val1=Math.trunc(e.value);
      this.setState({ temp: val1 });
    }else{
      var val2=-Math.trunc(e.value);
      this.setState({ temp: val2 });
    }
   
  };
  handleBlur = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp?this.state.temp:0,
    });
  };
  handleEditCell = () => {
    if(this.props.dataItem.isOpen==="Open" || this.props.dataItem.isOpen===true){

    this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
 const ownerId=dataItem.userId;
 const riskOwnerId=this.props.riskDetails?this.props.riskDetails.userId:null;

    const dataValue =
      dataItem[field] === null || dataItem[field] === undefined
        ? ""
        : dataItem[field];
        const impact=dataItem.impactResponse&&dataItem.impactResponse.find((item)=>item.name  == field);
    let access=false;
    if(impact){
      access=true;
    }
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
         <NumericTextBox
            defaultValue={dataValue}
            onChange={(e) => this.handleChange(e)}
            onBlur={this.handleBlur}
            id={this.props.field}
          />
        </td>
      );
    } else {
      if((loginUserId===ownerId||loginUserId===riskOwnerId)&&this.props.dataItem.isOpen===true&&access){
          return (
            <td onClick={this.handleEditCell}>{formatNumber(dataValue, "##,#")}</td>
          )
      }else{
        return this.props.dataItem.role === "View Only"|| this.props.dataItem.role === "Standard User"||this.props.dataItem.isOpen===false || !access ? (
          <td>{formatNumber(dataValue, "##,#")}</td>
        ) : (
          <td onClick={this.handleEditCell}>{formatNumber(dataValue, "##,#")}</td>
        );
      }
     
    }
  }
}
